/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Container } from "../../../utils/CustomComponents";
import dots from "../../../img/About/dotted-shape.svg";
import shape from "../../../img/About/shape-2.svg";
import team1 from "../../../img/About/team-01.png";
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/all";
function About() {
    return (
        <div id="about">
            <Container>
                <h1 className="header">about us</h1>
                <p>
                    The main ‘thrust’ is to decentralize the pension system, ensuring pensioners
                    have access to their pensions, eliminating the risk of fiat currency devaluation
                    by converting your pensions funds to Stable CryptoCurrency tokens seamlessly on
                    our platform. You also have the option to convert this stable Crypto Currency to
                    a few other Cryto Tokens and stakes, to earn more with your pension.
                </p>
                <p>
                    Finally, you monitor your pension funds on your wallet and have access to your
                    pension immediately after retirement or in other conditions.
                </p>
                <p>
                    Our Vision: To ensure a 100% Payback of the labour of workers with the best
                    Pension System that we have provided, to ensure everyone is pensionable and to
                    promote the dignity of labour.
                </p>
                <p>
                    Our Mission: To give back to Pensioners power over their Pensions, ensuring a
                    very seamless, stress-free and timely delivery of their pensions.
                </p>
            </Container>
            <Container>
                <h1 className="header">Meet The Team</h1>
                <div className="team_row">
                    <div className="col-xl-3 col-lg-3 col-sm-6">
                        <div className="ud-single-team">
                            <div className="ud-team-image-wrapper">
                                <div className="ud-team-image">
                                    <img src={team1} alt="team" />
                                </div>

                                <img src={dots} alt="shape" className="shape shape-1" />
                                <img src={shape} alt="shape" className="shape shape-2" />
                            </div>
                            <div className="ud-team-info">
                                <h5>Adveen Desuza</h5>
                                <h6>UI Designer</h6>
                            </div>
                            <ul className="ud-team-socials">
                                <li>
                                    <a href="">
                                        <FaFacebookF />
                                    </a>
                                </li>
                                <li>
                                    <a href="">
                                        <FaTwitter />
                                    </a>
                                </li>
                                <li>
                                    <a href="">
                                        <FaInstagram />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-sm-6">
                        <div className="ud-single-team">
                            <div className="ud-team-image-wrapper">
                                <div className="ud-team-image">
                                    <img src={team1} alt="team" />
                                </div>

                                <img src={dots} alt="shape" className="shape shape-1" />
                                <img src={shape} alt="shape" className="shape shape-2" />
                            </div>
                            <div className="ud-team-info">
                                <h5>Adveen Desuza</h5>
                                <h6>UI Designer</h6>
                            </div>
                            <ul className="ud-team-socials">
                                <li>
                                    <a href="javascript:void(0)">
                                        <FaFacebookF />
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">
                                        <FaTwitter />
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">
                                        <FaInstagram />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-sm-6">
                        <div className="ud-single-team">
                            <div className="ud-team-image-wrapper">
                                <div className="ud-team-image">
                                    <img src={team1} alt="team" />
                                </div>

                                <img src={dots} alt="shape" className="shape shape-1" />
                                <img src={shape} alt="shape" className="shape shape-2" />
                            </div>
                            <div className="ud-team-info">
                                <h5>Adveen Desuza</h5>
                                <h6>UI Designer</h6>
                            </div>
                            <ul className="ud-team-socials">
                                <li>
                                    <a href="javascript:void(0)">
                                        <FaFacebookF />
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">
                                        <FaTwitter />
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">
                                        <FaInstagram />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default About;
